export var SET_AGENT_TEASER = 'SET_AGENT_TEASER_DATA';
export var SET_AGENT_TEASER_LOGGED_IN = 'SET_AGENT_TEASER_LOGGED_IN';